import styled from "styled-components"

export const Wrap = styled.div`
  height: 100%;
  width: 65%;
  flex-direction: column;
  text-align: left;

  position: relative;
  margin: 0 0 0 35%;

  @media screen and (max-width: 979px) {
    width: 100%;
    margin: 0;
  }
`
export const Center = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: 992px) {
    width: 95%;
  }
`

export const Card = styled.div`
  width: 350px;
  height: 450px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  position: relative;
  margin: 2em auto;
`

export const Header = styled.div`
  width: 100%;
  height: 40%;
  background: #ddd;
  position: absolute;
  top: 0;
  -webkit-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -moz-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -ms-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -o-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  &:hover {
    margin-top: -20px;
  }
  img {
    max-width: 100%;
    height: auto;
    transition: ease-in-out 600ms;
    &:hover {
      transform: translatey(-10px) translatex(-5px) scale(1.05);
    }
  }
`

export const Body = styled.div`
  width: 100%;
  height: 60%;
  background: #fff;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -moz-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -ms-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  -o-transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  transition: cubic-bezier(0.68, -0.55, 0.27, 01.55) 320ms;
  cursor: pointer;
  &:hover {
    height: 50%;
  }
`

export const BodyContent = styled.div`
  width: 80%;
  height: 80%;
  background: #fff;
  position: relative;

  h1 {
    font-family: "Quicksand", sans-serif;
    font-weight: 450;
    font-size: 1.4em;
    text-align: center;
  }

  p {
    font-family: "Quicksand", sans-serif;
    font-weight: 300;
    font-size: 1em;
    text-align: center;
  }
`
